import {Route, Routes} from '@angular/router';
import {ConfigRouteEnum} from "./shared/enums/config-route.enum";
import {
    TranslationOverviewComponent
} from "./translations/components/translation-overview/translation-overview.component";
import {TranslationDetailComponent} from "./translations/components/translation-detail/translation-detail.component";
import {TranslationEditComponent} from "./translations/components/translation-edit/translation-edit.component";
import {QueryDetailComponent} from "./query/components/query-detail/query-detail.component";
import {canActivateAuthRole} from "./keycloak/guards/auth.guard";
import {QueryOverviewComponent} from "./query/components/query-overview/query-overview.component";
import {QueryEditComponent} from "./query/components/query-edit/query-edit.component";
import {NotAllowedComponent} from "./keycloak/not-allowed/not-allowed.component";
import {routeRoleConfig} from "./shared/routeRoleConfig";
import {ConfigRoutesDataModel} from "./shared/models/config-routes-data.model";
import {QueryComponent} from "./query/components/query/query.component";
import {AppSettingsOverviewComponent} from "./app-settings/components/app-settings-overview/app-settings-overview";
import {AppSettingsTableComponent} from "./app-settings/components/app-settings-table/app-settings-table.component";
import {AppSettingsDetailComponent} from "./app-settings/components/app-settings-detail/app-settings-detail";
import {AppSettingsCreate} from "./app-settings/components/app-settings-create/app-settings-create";
import {configWriteGuard} from "./keycloak/guards/config-write.guard";
import {JsonataExpressionsComponent} from "./jsonata-expressions/components/jsonata-expressions/jsonata-expressions.component";
import {JsonataExpressionsOverviewComponent} from "./jsonata-expressions/components/jsonata-expressions-overview/jsonata-expressions-overview.component";

export const translationRoute: Route = {
    path: '',
    children: [
        {
            path: ConfigRouteEnum.TRANSLATIONS,
            children: [
                {
                    path: '',
                    component: TranslationOverviewComponent,
                    data: {roles: routeRoleConfig.translations} as ConfigRoutesDataModel
                },
                {
                    path: ':searchName',
                    children: [
                        {
                            path: '',
                            component: TranslationDetailComponent,
                            data: {roles: routeRoleConfig.translations} as ConfigRoutesDataModel
                        },
                        {
                            path: ':identification',
                            component: TranslationEditComponent,
                            data: {roles: routeRoleConfig.translations} as ConfigRoutesDataModel
                        }
                    ]
                }
            ]
        }
    ]
}

export const queryRoute: Route = {
    path: '',
    children: [
        {
            path: ConfigRouteEnum.QUERY,
            children: [
                {
                    path: '',
                    component: QueryComponent,
                    data: {roles: routeRoleConfig.query} as ConfigRoutesDataModel
                },
                {
                    path: 'new',
                    component: QueryEditComponent,
                    data: {roles: routeRoleConfig.query} as ConfigRoutesDataModel
                },
                {
                    path: ':searchName',
                    children: [
                        {
                            path: '',
                            component: QueryOverviewComponent,
                            data: {roles: routeRoleConfig.query} as ConfigRoutesDataModel
                        },
                        {
                            path: ':id',
                            children: [
                                {
                                    path: '',
                                    component: QueryDetailComponent,
                                    data: {roles: routeRoleConfig.query} as ConfigRoutesDataModel
                                },
                                {
                                    path: 'edit',
                                    component: QueryEditComponent,
                                    data: {roles: routeRoleConfig.query} as ConfigRoutesDataModel
                                },
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}

export const appSettingsRoute: Route = {
    path: '',
    children: [
        {
            path: ConfigRouteEnum.APP_SETTINGS,
            children: [
                {
                    path: '',
                    component: AppSettingsOverviewComponent,
                    data: {roles: routeRoleConfig.appSettings} as ConfigRoutesDataModel
                },
                {
                    path: 'new',
                    component: AppSettingsCreate,
                    canActivate: [configWriteGuard],
                    data: {roles: routeRoleConfig.appSettings} as ConfigRoutesDataModel
                },
                {
                    path: ':searchName',
                    children: [
                        {
                            path: '',
                            component: AppSettingsTableComponent,
                            data: {roles: routeRoleConfig.appSettings} as ConfigRoutesDataModel
                        },
                        {
                            path: ':id',
                            children: [
                                {
                                    path: '',
                                    component: AppSettingsDetailComponent,
                                    data: {roles: routeRoleConfig.appSettings} as ConfigRoutesDataModel
                                }
                            ]
                        }
                    ]
                }
            ]
        },
    ]
}

export const jsonataRoute: Route = {
    path: '',
    children: [
        {
            path: ConfigRouteEnum.JSONATA,
            children: [
                {
                    path: '',
                    component: JsonataExpressionsOverviewComponent,
                    data: {roles: routeRoleConfig.jsonata} as ConfigRoutesDataModel
                },
                {
                    path: ':id',
                    component: JsonataExpressionsComponent,
                    data: {roles: routeRoleConfig.jsonata} as ConfigRoutesDataModel,
                }
            ]
        }
    ]
}

export const routes: Routes = [
    {
        path: ConfigRouteEnum.AUTH,
        loadComponent: () => import('./layouts/login/login.component').then(m => m.LoginComponent),
    },
    {
        path: ConfigRouteEnum.NOT_ALLOWED,
        component: NotAllowedComponent
    },
    {
        path: '',
        loadComponent: () => import('./layouts/default/default.component').then(m => m.DefaultComponent),
        canActivate: [canActivateAuthRole],
        children: [
            {
                path: ConfigRouteEnum.HOME,
                loadComponent: () => import('./shared/components/config-landing/config-landing.component').then(m => m.ConfigLandingComponent),
            },
            translationRoute,
            queryRoute,
            appSettingsRoute,
            jsonataRoute,
        ]
    },
];